var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisposalMarketValue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.563 8.456A10 10 0 0 0 6 15.893m3.437 7.545A10 10 0 0 0 26 16",
    stroke: "#F1A7A7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m25.3 7 .145 3.026c.036.766-.588 1.4-1.354 1.375L21 11.3M6.7 24.878l-.145-3.026a1.313 1.313 0 0 1 1.354-1.374l3.091.1",
    stroke: "#DF3030",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.105 10.813v.75m0 8.875v.75",
    stroke: "#E44E4E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.023 18.083c0-.208-.046-.401-.14-.578-.089-.183-.274-.347-.555-.492-.276-.152-.693-.282-1.25-.391a9.913 9.913 0 0 1-1.273-.352 3.861 3.861 0 0 1-.961-.492 2.063 2.063 0 0 1-.602-.68 1.895 1.895 0 0 1-.21-.914c0-.333.072-.648.218-.945a2.53 2.53 0 0 1 .633-.789 3.08 3.08 0 0 1 .992-.54 4.01 4.01 0 0 1 1.29-.194c.676 0 1.254.12 1.733.359.48.24.847.56 1.102.96.255.397.383.837.383 1.321h-1.445c0-.234-.07-.46-.211-.68a1.557 1.557 0 0 0-.602-.554c-.26-.146-.58-.219-.96-.219-.402 0-.727.063-.977.188a1.26 1.26 0 0 0-.54.46 1.161 1.161 0 0 0-.085 1.016c.057.12.156.232.296.336.141.1.339.193.594.281.255.089.58.178.977.266.692.156 1.263.344 1.71.563.448.218.782.486 1 .804.22.318.329.703.329 1.156a2.252 2.252 0 0 1-.899 1.813c-.286.219-.63.39-1.03.516-.397.12-.842.18-1.337.18-.745 0-1.375-.134-1.89-.4-.516-.265-.907-.609-1.172-1.03a2.468 2.468 0 0 1-.399-1.336h1.453c.021.395.136.71.344.945.208.23.464.393.766.492.302.094.601.14.898.14.396 0 .727-.051.992-.155.271-.105.477-.248.617-.43a.992.992 0 0 0 .211-.625Z",
    fill: "#E44E4E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisposalMarketValue);
export default __webpack_public_path__ + "static/media/disposalMarketValue.c97f1af74b42eb5b96e1cc802279b1d1.svg";
export { ForwardRef as ReactComponent };